import { FC } from "react";
import { Col, Row } from "antd";
import { useBreakpoints } from "@hooks/common/useBreakPoints";
import { useAntToken } from "@hooks/common/useAntToken";
import LineItemsTable from "./LineItemsTable";
import LineItemsList from "./LineItemsList";
import { ILineItem, TGlCode, TUnit } from "@Component/Common/types";
interface IInvoiceLineItemsProps {
  lineItems: ILineItem[];
  glCodes?: TGlCode[];
  handleLineItemDelete?: (value: number) => void;
  editGLCodes?: boolean;
  selectedRowTaxable?: boolean;
  onSelectedRowTaxableChange?: (checked: boolean) => void;
  handleEditLineItem?: (
    lineItemId: string,
    lineItemChangeKey: string,
    lineItemValue: unknown
  ) => void;
  loading?: boolean;
  units: TUnit[];
  propertyType: string;
  readOnly: boolean;
}
const InvoiceLineItems: FC<IInvoiceLineItemsProps> = (props) => {
  const {
    lineItems,
    glCodes,
    handleLineItemDelete,
    editGLCodes,
    onSelectedRowTaxableChange,
    selectedRowTaxable,
    handleEditLineItem,
    units,
    propertyType,
    readOnly
  } = props;
  const { isScreenXL } = useBreakpoints();
  const { token } = useAntToken();

  return (
    <Row
      style={{
        marginTop: token.marginXXS
      }}
      justify="center">
      <Col span={23}>
        <Row justify="center">
          <Col style={{ width: "100%" }}>
            {!isScreenXL ? (
              <LineItemsList
                editGLCodes={editGLCodes}
                glCodes={glCodes}
                handleLineItemDelete={handleLineItemDelete}
                lineItems={lineItems}
                handleEditLineItem={handleEditLineItem}
                units={units}
                propertyType={propertyType}
                readOnly={readOnly}
              />
            ) : (
              <LineItemsTable
                editGLCodes={editGLCodes}
                glCodes={glCodes}
                handleLineItemDelete={handleLineItemDelete}
                lineItems={lineItems}
                onSelectedRowTaxableChange={onSelectedRowTaxableChange}
                selectedRowTaxable={selectedRowTaxable}
                handleEditLineItem={handleEditLineItem}
                units={units}
                propertyType={propertyType}
                readOnly={readOnly}
              />
            )}
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default InvoiceLineItems;
